<template>
  <div class="akun-page">
    <Header />
    <div class="container py-4">
      <!-- Add Account Section -->
      <div class="row justify-content-center mb-5">
        <div class="col-lg-8">
          <div class="card shadow-sm border-0">
            <div class="card-header border-bottom-0 pt-4 pb-0">
              <h5 class="fw-bold text-primary mb-0">
                <i class="bi bi-person-plus-fill me-2"></i>Tambahno akun gae {{ orangnya }}
              </h5>
            </div>
            <div class="card-body">
              <form @submit.prevent="add">
                <div class="mb-3">
                  <label for="jenis_akun" class="form-label text-muted small fw-bold">Jenis akun</label>
                  <input 
                    type="text" 
                    id="jenis_akun" 
                    class="form-control" 
                    v-model="dataAkun.jenis_akun" 
                    placeholder="misal: Gmail, Facebook, Bank"
                    autocomplete="off"
                    required
                  >
                </div>
                <div class="mb-3">
                  <label for="datanya" class="form-label text-muted small fw-bold">DETAILS (Username/Password)</label>
                  <textarea 
                    id="datanya" 
                    class="form-control" 
                    rows="4" 
                    v-model="dataAkun.datanya"
                    placeholder="Ojo lali isien detail akun kene, pisahno nganggo enter"
                    required
                  ></textarea>
                </div>
                <div class="d-flex justify-content-end">
                  <button type="submit" class="btn btn-primary px-4">
                    Simpan
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Search & List Section -->
      <div class="row mb-3 align-items-center">
        <div class="col-md-6">
          <h4 class="fw-bold mb-0">List Akun</h4>
        </div>
        <div class="col-md-6">
           <div class="input-group">
             <span class="input-group-text border-end-0"><i class="bi bi-search"></i></span>
             <input type="text" class="form-control border-start-0 ps-0" placeholder="Cari berdasarkan jenis akun..." v-model="searchQuery">
           </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12"><hr class="mt-0 mb-4"></div>
      </div>

      <div class="row g-4 masonry-grid">
        <div class="col-md-6 col-lg-4" v-for="dtmhs in filteredData" :key="dtmhs.key">
          <div class="card h-100 shadow-sm border-0 note-card" style="cursor: pointer;" @click="openDetail(dtmhs)">
            <div class="d-flex flex-column h-100">
              <div class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center">
                <h5 class="card-title fw-bold mb-0 text-truncate" :title="dtmhs.jenis_akun">{{ dtmhs.jenis_akun }}</h5>
              </div>
              <div class="card-body">
                <p class="card-text note-content text-truncate-multiline" v-html="dtmhs.datanya"></p>
              </div>
              <div class="card-footer bg-transparent border-0 text-end">
                <small class="text-primary fst-italic">klik kanggo ndeleng details</small>
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="filteredData.length === 0" class="col-12 text-center py-5">
           <p class="text-muted fs-5">
             <span v-if="searchQuery">No accounts match your search.</span>
             <span v-else>No accounts found. Add your first account above!</span>
           </p>
        </div>
      </div>
    </div>

    <!-- Detail & Edit Modal -->
    <div class="modal fade" id="detailModal" tabindex="-1" aria-hidden="true" ref="detailModal" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content border-0 shadow">
          
          <!-- View Mode Header -->
          <div class="modal-header border-bottom-0" v-if="!isEditing">
            <h5 class="modal-title fw-bold text-primary">{{ selectedItem.jenis_akun }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <!-- Edit Mode Header -->
          <div class="modal-header border-bottom-0" v-else>
            <h5 class="modal-title fw-bold text-warning">Edit Account</h5>
          </div>

          <div class="modal-body">
            <!-- View Mode Content -->
            <div v-if="!isEditing">
               <p class="note-content" v-html="selectedItem.datanya"></p>
            </div>
            
            <!-- Edit Mode Content -->
            <div v-else>
               <div class="mb-3">
                 <label class="form-label small text-muted">Service Name</label>
                 <input type="text" class="form-control" v-model="editForm.jenis_akun">
               </div>
               <div class="mb-3">
                 <label class="form-label small text-muted">Details (Username/Password)</label>
                 <textarea class="form-control" rows="8" v-model="editForm.datanya"></textarea>
               </div>
            </div>
          </div>

          <div class="modal-footer border-top-0 justify-content-between">
            <!-- View Mode Buttons -->
            <div v-if="!isEditing" class="w-100 d-flex justify-content-end gap-2">
               <button type="button" class="btn btn-outline-danger" @click="confirmDelete(selectedItem.key)">
                 <i class="bi bi-trash"></i> Delete
               </button>
               <button type="button" class="btn btn-warning text-white" @click="startEdit">
                 <i class="bi bi-pencil"></i> Edit
               </button>
               <button type="button" class="btn btn-secondary rounded-pill px-4" data-bs-dismiss="modal">Close</button>
            </div>
            
            <!-- Edit Mode Buttons -->
            <div v-else class="w-100 d-flex justify-content-end gap-2">
               <button type="button" class="btn btn-secondary" @click="cancelEdit">Cancel</button>
               <button type="button" class="btn btn-primary" @click="saveEdit">Save Changes</button>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { db } from '../firebase.js'
import { Modal } from 'bootstrap'

export default {
  name: 'Akun',
  components: {
    Header
  },
  data () {
      return {
        dataAkun: {
          jenis_akun: '',
          datanya: '',
          edit: false
        },
        datanya : [],
        searchQuery: '',
        selectedItem: {},
        editForm: {},
        isEditing: false,
        modalInstance: null
      }
    },
  computed: {
      orangnya() {
          return this.$route.params.orangnya
      },
      filteredData() {
        if (!this.searchQuery) {
          return this.datanya;
        }
        const lowerQuery = this.searchQuery.toLowerCase();
        return this.datanya.filter(item => 
          item.jenis_akun.toLowerCase().includes(lowerQuery)
        );
      }
  },
  methods: {
      openDetail(item) {
        this.selectedItem = item;
        this.isEditing = false;
        if (!this.modalInstance) {
          this.modalInstance = new Modal(this.$refs.detailModal);
        }
        this.modalInstance.show();
      },
      add(){
          let keluargaRef = db.ref(`myfamily/${this.$route.params.orangnya}/akun`)
          keluargaRef.push(this.dataAkun)
          this.dataAkun.jenis_akun = ''
          this.dataAkun.datanya = ''
          Swal.fire({
            title: 'Success',
            text: 'Account added successfully',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
          })
      },
      startEdit() {
        this.editForm = { ...this.selectedItem }; // Clone data
        this.isEditing = true;
      },
      cancelEdit() {
        this.isEditing = false;
        this.editForm = {};
      },
      saveEdit() {
        const key = this.selectedItem.key;
        let keluargaRef = db.ref(`myfamily/${this.$route.params.orangnya}/akun`)
        
        keluargaRef.child(key).update({
          jenis_akun: this.editForm.jenis_akun,
          datanya: this.editForm.datanya
        }).then(() => {
          this.isEditing = false;
          // Update selectedItem to reflect changes immediately
          this.selectedItem = { ...this.selectedItem, ...this.editForm };
          Swal.fire({
            title: 'Saved!',
            text: 'Account updated successfully',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
          })
        });
      },
      confirmDelete(key) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            let keluargaRef = db.ref(`myfamily/${this.$route.params.orangnya}/akun`)
            keluargaRef.child(key).remove();
            
            // Close modal
            if (this.modalInstance) {
              this.modalInstance.hide();
            }
            
            Swal.fire(
              'Deleted!',
              'Account has been deleted.',
              'success'
            )
          }
        })
      }
  },
  mounted() {
    this.datanya = []
    var dt = db.ref(`myfamily/${this.orangnya}/akun`)
    dt.on('value', (snapshot) => {
        const items = []
        snapshot.forEach((childSnapshot) => {
            var dt = childSnapshot.val();
            items.push({key:childSnapshot.key, jenis_akun:dt.jenis_akun, datanya: dt.datanya, edit: false})
        })
        this.datanya = items
        
        if (this.selectedItem.key) {
           const updatedItem = items.find(i => i.key === this.selectedItem.key);
           if (updatedItem && !this.isEditing) {
               this.selectedItem = updatedItem;
           }
        }
    });
  },
  beforeUnmount() {
    var dt = db.ref(`myfamily/${this.orangnya}/akun`)
    dt.off()
    this.datanya = []
    if (this.modalInstance) {
      this.modalInstance.dispose()
    }
  },
}
</script>

<style scoped>
.note-content {
  white-space: pre-wrap;
  color: #555;
  font-family: monospace; /* Monospace for passwords often helps legibility */
  max-height: 40vh; /* Max height for scrollable content */
  overflow-y: auto; /* Enable vertical scrolling */
  padding-right: 10px; /* Space for scrollbar */
}
.note-card {
  transition: transform 0.2s;
  overflow: visible; /* Allow dropdown to overflow */
}
.note-card:hover,
.note-card:focus-within {
  transform: translateY(-3px);
  z-index: 10; /* Ensure card is above others when interacting */
  position: relative;
}
.text-truncate-multiline {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>

<style scoped>
.note-content {
  white-space: pre-wrap;
  color: #555;
  font-family: monospace; /* Monospace for passwords often helps legibility */
}
.note-card {
  transition: transform 0.2s;
}
.note-card:hover {
  transform: translateY(-3px);
}
</style>